export default __webpack_public_path__ + "static/media/testing-types.8ad3582d.svg";